import { CommonDeviceTypeEnumResponse } from '@/api/services/common/device-type/common-device-type.dto'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationDeviceResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'
import { configurationDeviceService } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.service'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { getEnumColumnGridOptions } from '@/grid/base-grid-options'
import { store } from '@/store/store'

export const columnsDefInstrumentationDevicesGrid =
    (deviceTypes: CommonDeviceTypeEnumResponse[]): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('configuration.grid.device'),
            type: AgGridColumnType.TEXT,
            colId: 'code',
            field: 'name',
            minWidth: 200,
            flex: 1
        },
        {
            headerName: i18n.tc('configuration.grid.deviceModel'),
            type: AgGridColumnType.TEXT,
            field: 'model',
            minWidth: 190,
            flex: 1
        },
        {
            ...getEnumColumnGridOptions(deviceTypes, 'code', 'translatedName'),
            headerName: i18n.tc('configuration.grid.deviceType'),
            type: AgGridColumnType.TEXT,
            colId: 'type',
            field: 'type.translatedName',
            minWidth: 190,
            flex: 1
        },
        {
            headerName: i18n.tc('configuration.grid.hasIntegration'),
            type: AgGridColumnType.CHECK_ICON,
            field: 'hasIntegration',
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.tc('configuration.grid.active'),
            type: AgGridColumnType.CHECK_ICON,
            field: 'active',
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.tc('configuration.grid.useInternalViewer'),
            type: AgGridColumnType.CHECK_ICON,
            field: 'useInternalViewer',
            minWidth: 100,
            flex: 1
        }
    ]

export interface ConfigurationInstrumentationDevicesGridState extends CrudModelPaginatorLaboratory<ConfigurationDeviceResponse> {
    service: typeof configurationDeviceService,
    laboratoryId: number
}
export const initialConfigurationInstrumentationDevicesGridState =
    (): ConfigurationInstrumentationDevicesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.instrumentation.devices',
        columnsDef: columnsDefInstrumentationDevicesGrid([]),
        datasource: new PaginatorLaboratoryDatasource(configurationDeviceService, store.getters.labId),
        service: configurationDeviceService,
        laboratoryId: store.getters.labId
    })
